import { Pipe, PipeTransform } from "@angular/core";
import { Tools } from "@comunicare/comunicare-helper";
import { AbstractObservation, IObservationDefinition, IObservationResume } from "@comunicare/comunicare-interfaces";
import { SessionService } from "../../../providers/session.service";

@Pipe({ name: "translateObservationName" })
export class TranslateObservationNamePipe implements PipeTransform {
  constructor(private sessionService: SessionService) {}
  /**
   * Checks the observations' definitions for the name of an observation and returns it.
   * If there isn't a corresponding definition for this observation, it returns the display
   * of the observation (usually it is the question in the language it was presented to the user).
   * @param element (IObservationResume) the observation
   * @returns the translated name of the observation
   */
  transform(element: IObservationResume, allDefinitions: IObservationDefinition[]): string {
    const ref = AbstractObservation.ignoreSuffix(element.reference);
    const def = allDefinitions.find((d) => d.loinc === element.parentReference);
    if (!def) {
      return element.display;
    }
    const componentDef = def.components.find((d) => d.loinc === element.reference);
    const componentDefWithoutSuffix = def.components.find((d) => AbstractObservation.ignoreSuffix(d.loinc) === ref);
    if (componentDef) {
      // handle the 2 cases
      if (componentDef.shortnameTranslation) {
        return Tools.getTranslation(componentDef.shortnameTranslation, this.sessionService.userLang, componentDef.loinc);
      }

      return Tools.getTranslation(componentDef.nameTranslation, this.sessionService.userLang, componentDef.loinc);
    }

    if (componentDefWithoutSuffix) {
      if (componentDefWithoutSuffix.shortnameTranslation) {
        return Tools.getTranslation(
          componentDefWithoutSuffix.shortnameTranslation,
          this.sessionService.userLang,
          componentDefWithoutSuffix.loinc
        );
      }
      return Tools.getTranslation(componentDefWithoutSuffix.nameTranslation, this.sessionService.userLang, componentDefWithoutSuffix.loinc);
    }
    // if no definition was found, we simply return the display
    return element.display;
  }
}
